/**
 * Created by 槟 on 2018/4/10.
 */
export const UPDATE_SEARCH_RENT_DATA = 'releaseSearchRent/UPDATE_SEARCH_RENT_DATA';
const initialState = {
    releaseSearchRentData:{
        nullArr:[],
        nullArr2:[],
        districtId:'',        //小区
        rentalMode:1,        //合租
        minPrice:'',         //最低价
        maxPrice:'',         //最高价
        bldroomCount:'',     //室
        hallCount:'',        //厅
        minArea:'',          //最小面积
        maxArea:'',          //最大面积
        decorationLevel:'',  //装修标准
        checkInDate:'',     //入住日期
        checkInAmount:'',   //入住人数
        overDate:false,
    },
};
const releaseSearchRentDataReducer =  (releaseSearchRentData=0, action)=>{
    switch (action.type) {
        case UPDATE_SEARCH_RENT_DATA:
            return {
                ...releaseSearchRentData,
                [action.subType]:action.data
            }
        default:
            return releaseSearchRentData
    }
}
export default (state = initialState, action) => {
    return {
        releaseSearchRentData : releaseSearchRentDataReducer(state.releaseSearchRentData, action)
    };
}
export const dispatch_func = {
    update_releaseSearchRentData : (data,type) => {
        return dispatch => {
            dispatch({
                type: UPDATE_SEARCH_RENT_DATA,
                data:data,
                subType:type
            });
        }
    },
};


// WEBPACK FOOTER //
// ./src/modules/releaseSearchRent.js